<template>
  <div>
    <v-dialog
      v-model="isShowDialog"
      persistent
      :width="matchPanelSize"
      transition="dialog-top-transition"
      :fullscreen="$vuetify.breakpoint.name == 'xs'"
    >
      <v-card>
        <v-card-title>
          <v-row no-gutters>
            <v-col class="d-flex justify-space-between col-12">
              <span>FIND OBJECT LIST: {{ FindData.SubDeviceTypeId == null? 0 : findDataTableComputed.length }}</span>
              <div>
                <v-btn 
                  :disabled="loading"
                  outlined
                  @click="findObjectHide"
                  class="text-right text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                  :x-large="$vuetify.breakpoint.name == 'xl'"
                  :large="$vuetify.breakpoint.name == 'lg'"
                >
                  <v-icon color="white">
                    mdi-close
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col class="d-flex col-12 mt-4" :class="$vuetify.breakpoint.name == 'sm' ? 'justify-end' : 'justify-space-between'">
              <v-btn  depressed outlined class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6 mr-4"
                :x-large="$vuetify.breakpoint.name == 'xl'"
                :large="$vuetify.breakpoint.name == 'lg'" @click="clearFindObject">
                CLEAR
              </v-btn>
              <download-excel
                :data="reportData"
                worksheet="DVC Report"
                :fields="json_fields"
                :name="`${dateOne}report.xls`"
              >
                <v-btn :disabled="loading || findDataTableComputed.length == 0 || FindData.SubDeviceTypeId == null"
                  depressed outlined class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                  :x-large="$vuetify.breakpoint.name == 'xl'"
                  :large="$vuetify.breakpoint.name == 'lg'" @click="createReport">
                  CREATE REPORT
                </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <v-row no-gutters class="d-flex justify-space-around">
                <v-col class="col-12">
                  <v-row class="mt-1">
                    <v-col class="col-12 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                      <v-select
                        dense
                        :disabled="loading"
                        outlined
                        hide-details
                        persistent-hint
                        v-model="FindData.SubDeviceTypeId"
                        :items="subDeviceTypesAndAll"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Controller Type"
                      ></v-select>
                    </v-col>
                    <v-col class="col-12">
                      <v-row>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-text-field
                            class=""
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            v-model="FindData.FirstName"
                            label="First name/Last name"
                            outlined
                            dense
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-text-field
                            class=""
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            v-model="FindData.Email"
                            label="Login/Email"
                            outlined
                            dense
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-text-field
                            class=""
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            v-model="FindData.PhoneNumber"
                            label="PhoneNumber"
                            outlined
                            dense
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-text-field
                            class=""
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            v-model="FindData.DocumentNumber"
                            label="DocumentNumber"
                            outlined
                            dense
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col class="col-12">
                      <v-row>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-text-field
                            class=""
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            v-model="FindData.ObjectAddress"
                            label="Object adress"
                            outlined
                            dense
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-select
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            outlined
                            dense
                            hide-details
                            class=""
                            v-model="FindData.ImportanceRank"
                            :items="getSubjectCreationDatas.importanceRank"
                            item-text="name"
                            item-value="id"
                            :menu-props="{ maxHeight: '400', offsetY: true }"
                            label="Importance rank"
                            persistent-hint
                          ></v-select>
                        </v-col>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-text-field
                            class=""
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            label="SIM Number"
                            v-model="FindData.SIMNumber"
                            outlined
                            dense
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-text-field
                            v-model="FindData.MeterSerialNumber"
                            class=""
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            label="Meter Serial Number"
                            outlined
                            dense
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-text-field
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            label="DVC-Point IMEI"
                            v-model="FindData.IMEI"
                            outlined
                            dense
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-select
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            outlined
                            v-model="FindData.IsOnline"
                            :items="OnlineStatus"
                            :menu-props="{ maxHeight: '400', offsetY: true }"
                            label="Status"
                            item-text="name"
                            item-value="id"
                            persistent-hint
                            dense
                            hide-details
                          ></v-select>
                        </v-col>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-select
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            outlined
                            v-model="FindData.IsBatteryPower"
                            :items="powerType"
                            :menu-props="{ maxHeight: '400', offsetY: true }"
                            label="Power type"
                            item-text="name"
                            item-value="value"
                            persistent-hint
                            dense
                            hide-details
                          ></v-select>
                        </v-col>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-select
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            outlined
                            v-model="FindData.ProviderId"
                            :items="getSubjectCreationDatas.providers"
                            item-text="name"
                            item-value="id"
                            :menu-props="{ maxHeight: '400', offsetY: true }"
                            label="Provider"
                            persistent-hint
                            dense
                            hide-details
                          ></v-select>
                        </v-col>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-select
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            outlined
                            v-model="FindData.SimCorpId"
                            :items="getSubjectCreationDatas.simCorps"
                            item-text="name"
                            item-value="id"
                            :menu-props="{ maxHeight: '400', offsetY: true }"
                            label="Sim corporation"
                            persistent-hint
                            dense
                            hide-details
                          ></v-select>
                        </v-col>
                        <v-col class="col-6 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                          <v-select
                            :disabled="loading || FindData.SubDeviceTypeId == null"
                            outlined
                            v-model="FindData.SupplierId"
                            :items="getSubjectCreationDatas.suppliers"
                            item-text="title"
                            item-value="id"
                            class=""
                            :menu-props="{ maxHeight: '400', offsetY: true }"
                            label="Resource supplier"
                            persistent-hint
                            dense
                            hide-details
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="col-12 mt-5 d-flex justify-space-around justify-center">
                  <div class="fix-height scroll pa-1" v-if="findDataTableComputed.length > 0 && FindData.SubDeviceTypeId != null">
                    <v-data-table
                      disable-pagination
                      hide-default-footer
                      :headers="headersFindObjects"
                      :items="findDataTableComputed"
                      class="elevation-1"
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-icon
                          :color="getDeviceConnectedState.filter(d => d == item.device.id).length > 0 ? 'green' : 'red'"
                          small
                          class="mr-2"
                          @click="findObjectOnMap(item)"
                        >
                          mdi-map-marker-radius
                        </v-icon>
                      </template>
                    </v-data-table>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <Reports :isShowDialog="isShowDialogReports" @hideReports="isShowDialogReports = false"></Reports>
  </div>
</template>

<script>
  import Reports from './Reports.vue'
  import DownloadExcel from "vue-json-excel";
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  export default {
    props: ['isShowDialog'],
    name: 'FindObject',
    data(){
      return {
        isShowDialogReports: false,
        json_fields: {
          ID: "ID",
          ControllerType: 'ControllerType',
          OwnerFirstName: 'OwnerFirstName',
          OwnerLastName: 'OwnerLastName',
          OwnerLogin: 'OwnerLogin',
          OwnerPhoneNumber: 'OwnerPhoneNumber',
          OwnerDocumentNumber: 'OwnerDocumentNumber',
          OwnerDocumentNumber: 'OwnerDocumentNumber',
          ObjectAddress: 'ObjectAddress',
          ImportanceRank: 'ImportanceRank',
          SIMNumber: 'SIMNumber',
          MeterSerialNumber: 'MeterSerialNumber',
          IMEI: 'IMEI',
          Status: 'Status',
          IsBatteryPower: 'IsBatteryPower',
          Provider: 'Provider',
          SIMCorp: 'SIMCorp',
          Supplier: 'Supplier'
        },
        dateOne: new Date().toISOString().substring(0, 7),
        loading: false,
        powerType:[
          {
            name: 'All',
            value: null
          },
          {
            name: 'Battery',
            value: true
          },
          {
            name: 'PowerSupply',
            value: false
          }
        ],
        OnlineStatus: [
          {
            id: null,
            name: 'All'
          },
          {
            id: true,
            name: 'Online'
          },
          {
            id: false,
            name: 'Offline'
          }
        ],
        FindData: {
          SubDeviceTypeId: null,
          SupplierId: null,
          ImportanceRank: null,
          IsOnline: null,
          IsBatteryPower: null,
          ProviderId: null,
          SimCorpId: null,
          IMEI: null,
          MeterSerialNumber: null,
          SIMNumber: null,
          ObjectAddress: null,
          DocumentNumber: null,
          PhoneNumber: null,
          Email: null,
          FirstName: null
        },
        findDataTable: [],
        headersFindObjects: [
          {
            align: 'center',
            text: 'ID',
            sortable: true,
            value: 'SubjectId',
            width: '25%'
          },
          { 
            align: 'center',
            text: 'Device type',
            sortable: true,
            value: 'SubType',
            width: '15%'
          },
          { 
            align: 'left',
            text: 'Address',
            sortable: true,
            value: 'SubjectAddress',
            width: '50%'
          },
          { 
            align: 'center',
            text: 'Actions',
            sortable: false,
            value: 'actions',
            width: '10%'
          }
        ], 
        reportData: []
      }
    },
    components:{
      Reports,
      DownloadExcel
    },
    computed:{
      ...mapGetters(['getSubDeviceTypes', 'getSubjectCreationDatas', 'getDevicesData', 'getDeviceTypes', 'getDeviceConnectedState']),
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      },
      subDeviceTypesAndAll(){
        const dt = this.getSubDeviceTypes.map(dt => {
          return {
            id: dt.id,
            name: `DVC-Point+${dt.name}`
          }
        })
        dt.unshift({
            id: -1,
            name: `All`
          })
        console.log(dt)
        return dt
      },  
      findDataTableComputed(){
        return this.findDataTable
        .filter(data => {
          return this.FindData.SupplierId == null || this.FindData.SupplierId == data.device.supplierId
        })
        .filter(data => {
          if(this.FindData.SimCorpId == null){
            return true
          }
          const network = this.getSubjectCreationDatas.networks.filter(network => network.id == data.device.networkId)
          if(network.length == 0){
            return false
          }
          const simCorp = this.getSubjectCreationDatas.simCorps.filter(simCorp => simCorp.id == network[0].simCorpId)
          if(simCorp.length == 0){
            return false
          }
          return this.FindData.SimCorpId == simCorp[0].id
        })
        .filter(data => {
          if(this.FindData.ProviderId == null){
            return true
          }
          const network = this.getSubjectCreationDatas.networks.filter(network => network.id == data.device.networkId)
          if(network.length == 0){
            return false
          }
          const provider = this.getSubjectCreationDatas.providers.filter(provider => provider.id == network[0].providerId)
          if(provider.length == 0){
            return false
          }
          return this.FindData.ProviderId == provider[0].id
        })
        .filter(data => {
          return this.FindData.IsBatteryPower == null || this.FindData.IsBatteryPower == data.device.device.isBatteryPower
        })
        .filter(data => {
          return this.FindData.IsOnline == null || (data.device.disconnectionDate == null && this.FindData.IsOnline) || this.FindData.IsOnline == (new Date(data.device.disconnectionDate) < new Date(data.device.connectionDate))
        })
        .filter(data => {
          return this.FindData.IMEI == null || this.FindData.IMEI == '' 
            || this.FindData.IMEI == data.device.device.imei
        })
        .filter(data => {
          return this.FindData.MeterSerialNumber == null || this.FindData.MeterSerialNumber == '' 
            || this.FindData.MeterSerialNumber == data.device.subDevice.serialNumber
        })
        .filter(data => {
          return this.FindData.SIMNumber == null || this.FindData.SIMNumber == '' 
            || this.FindData.SIMNumber == data.device.device.phoneNumber
        })
        .filter(data => {
          return this.FindData.ImportanceRank == null || this.FindData.ImportanceRank == data.device.importanceRank
        })
        .filter(data => {
          return this.FindData.SubDeviceTypeId == null || this.FindData.SubDeviceTypeId == data.device.subDevice.typeId || this.FindData.SubDeviceTypeId == -1
        })
        .filter(data => {
          return this.FindData.FirstName == null || data.device.ownerUser.firstName.includes(this.FindData.FirstName) || data.device.ownerUser.lastName.includes(this.FindData.FirstName)
        })
        .filter(data => {
          return this.FindData.Email == null || data.device.ownerUser.email.includes(this.FindData.Email)
        })
        .filter(data => {
          return this.FindData.PhoneNumber == null || data.device.ownerUser.phoneNumber.includes(this.FindData.PhoneNumber)
        })
        .filter(data => {
          return this.FindData.DocumentNumber == null || data.device.ownerUser.document.number.includes(this.FindData.DocumentNumber)
        })
        .filter(data => {
          return this.FindData.ObjectAddress == null || data.device.address.fullAddress.includes(this.FindData.ObjectAddress)
        })
      }
    },
    async mounted(){
      this.$root.$on('showFindObjects', async () => {
        await this.mountDevices()
      })
    },
    methods:{
      ...mapActions([]),
      ...mapMutations([]),
      createReport(){
        const devices = this.findDataTableComputed.map(g => g.device)
        this.$root.$emit("showAllReports", devices)
        this.isShowDialogReports = true
        /*this.reportData = []
        this.findDataTableComputed.forEach(filteredData => {
          const network = this.getSubjectCreationDatas.networks.filter(network => network.id == filteredData.device.networkId)
          const provider = this.getSubjectCreationDatas.providers.filter(provider => provider.id == network[0].providerId)
          const simCorp = this.getSubjectCreationDatas.simCorps.filter(simCorp => simCorp.id == network[0].simCorpId)
          this.reportData.push({
            ID: filteredData.SubjectId,
            ControllerType: filteredData.SubType,
            OwnerFirstName: filteredData.device.ownerUser.firstName,
            OwnerLastName: filteredData.device.ownerUser.lastName,
            OwnerLogin: filteredData.device.ownerUser.email,
            OwnerPhoneNumber: filteredData.device.ownerUser.phoneNumber,
            OwnerDocumentNumber: filteredData.device.ownerUser.document.number,
            ObjectAddress: filteredData.SubjectAddress,
            ImportanceRank: this.getSubjectCreationDatas.importanceRank.filter(ir => ir.id == filteredData.device.importanceRank)[0].name,
            SIMNumber: filteredData.device.device.phoneNumber,
            MeterSerialNumber: filteredData.device.subDevice.serialNumber,
            IMEI: ` ${filteredData.device.device.imei} `,
            Status: (new Date(filteredData.device.disconnectionDate) < new Date(filteredData.device.connectionDate)) ? 'Online' : 'Offline',
            IsBatteryPower: this.powerType.filter(pt => pt.value == filteredData.device.device.isBatteryPower)[0].name,
            Provider: provider[0].name,
            SIMCorp: simCorp[0].name,
            Supplier: this.getSubjectCreationDatas.suppliers.filter(sp => sp.id == filteredData.device.supplierId)[0].title
          })
        })*/
      },
      clearFindObject(){
        Object.keys(this.FindData).forEach(key => {
          this.FindData[key] = null
        })
      },
      findObjectOnMap(data){
        this.$emit("FindObjectHide")
        this.$root.$emit("markerClick", data.device)
      },
      findObjectHide(){
        this.$emit("FindObjectHide")
      },
      async mountDevices(){
        this.findDataTable = []
        this.getDevicesData.forEach(device => {
          const trueId = `000${device.id}`
          this.findDataTable.push({
            SubjectId: `DVC ${trueId.substring(trueId.length-3, trueId.length)}`,
            SubjectAddress: device.address.fullAddress,
            SubType: `${this.getDeviceTypes.filter(sb => sb.id == device.device.deviceTypeId)[0].name}+${this.getSubDeviceTypes.filter(sb => sb.id == device.subDevice.typeId)[0].name}`,
            device: device
          })
        })
        /*if(this.reportData.length > 0){
          this.selectedDevice = this.reportData[0].device
          await this.loadDeviceSensors()
        }
        this.mountBaseHeaders()*/
      },
    }
  }
</script>
<style>
.fix-margin{
}
</style>
